import { isEmpty, mergeRight, propOr } from 'ramda';
import { api, setter, fetchParams, fetchResponse } from '@/modules/helper';
import { stripExtensionCode } from '@/utils/helper';

export default {
  namespaced: true,

  state: {
    items: [],
    pagination: {
      skip: 0,
      limit: 10,
    },
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items(state) {
      return state.items;
    },
  },

  actions: {
    create(state, payload) {
      return api.post('shop', payload);
    },

    update(state, payload) {
      return api.patch(`shop/${payload.id}`, payload);
    },

    fetch({ commit, state }, payload) {
      const hardFetch = propOr(false, 'hardFetch', payload);

      if (isEmpty(state.items) || hardFetch) {
        return api
          .get('shop', {
            params: fetchParams(state, payload),
          })
          .then(data => commit('dynamicSet', fetchResponse(data)));
      }
    },

    find(state, id) {
      return api
        .get(`shop/${id}`)
        .then(({ data }) =>
          mergeRight(data, {
            telephone_no: stripExtensionCode(data.telephone_no),
          }),
        )
        .catch(error => error);
    },

    remove({ dispatch }, id) {
      return api.delete(`shop/${id}`).then(() => dispatch('fetch'));
    },

    reactivate({ dispatch }, id) {
      return api.patch(`shop/reactivate/${id}`).then(() => dispatch('fetch'));
    },

    exportData({ state }, payload) {
      return api.get('shop/export', {
        responseType: 'blob',
        params: fetchParams(state, payload),
      });
    },
  },
};
